import config from '../config';

function getLogoUrl(background: string, fileExtension: string): Record<string, string> {
    return { [background]: `${config.domain}/${config.backgroundsFolder}/${background}.${fileExtension}` };
}

export type BridgeWarBackgrounds = Record<string, string>;

export const bridgeWarBackgrounds: BridgeWarBackgrounds = {
    ...getLogoUrl('house_hearts', 'jpg'),
};
